import React, {
  createContext,
  Dispatch,
  FC,
  SetStateAction,
  useMemo,
  useRef,
} from "react";
import { PippaIngressSource } from "@app/pippa/models/analytics";

interface PippaProviderProps {
  children: React.ReactNode;
  isWidgetOpen: boolean;
  setIsWidgetOpen: Dispatch<SetStateAction<boolean>>;
  ingressSource?: PippaIngressSource;
}

interface PippaController {
  startDate: Date;
  isWidgetOpen: boolean;
  setIsWidgetOpen: Dispatch<SetStateAction<boolean>>;
  ingressSource?: PippaIngressSource;
}

export const Context = createContext<PippaController>({
  startDate: new Date(),
  isWidgetOpen: false,
  setIsWidgetOpen: () => undefined,
});

Context.displayName = "PippaContext";

const PippaProvider: FC<PippaProviderProps> = ({
  children,
  isWidgetOpen,
  setIsWidgetOpen,
  ingressSource,
}) => {
  const startDate = useRef(new Date());

  const value = useMemo(
    () => ({
      startDate: startDate.current,
      isWidgetOpen,
      setIsWidgetOpen,
      ingressSource,
    }),
    [startDate, isWidgetOpen, ingressSource]
  );

  return <Context.Provider value={value}>{children}</Context.Provider>;
};

export default PippaProvider;
